export default {"src":"/_next/static/media/share-icon.eee14d9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};